import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ScannerQuestionIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <g id='Barcode'>
        <g id='Vector_2'>
          <path
            d='M11.5 3.33333H14V5.83333'
            fill='white'
          />
          <path
            d='M11.5 3.33333H14V5.83333'
            stroke='#3E8FFA'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <g id='Vector_3'>
          <path
            d='M4.5 13.3333H2V10.8333'
            fill='white'
          />
          <path
            d='M4.5 13.3333H2V10.8333'
            stroke='#3E8FFA'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <path
          id='Vector_4'
          d='M14 10.8333V13.3333H11.5'
          stroke='#3E8FFA'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_5'
          d='M2 5.83333V3.33333H4.5'
          stroke='#3E8FFA'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_6'
          d='M5 5.83333V10.8333'
          stroke='#3E8FFA'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_7'
          d='M11 5.83333V10.8333'
          stroke='#3E8FFA'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_8'
          d='M9 5.83333V10.8333'
          stroke='#3E8FFA'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_9'
          d='M7 5.83333V10.8333'
          stroke='#3E8FFA'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </SvgIcon>
  );
}
